import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IAuth } from './model';

export const selectAuthFeat = createFeatureSelector<Readonly<IAuth>>('auth');
export const selectUser = createSelector(selectAuthFeat, (auth: IAuth) => auth.user);
export const selectEmployee = createSelector(selectAuthFeat, (auth: IAuth) => auth.employee);
export const selectUserState = createSelector(selectAuthFeat, (auth: IAuth) => auth.user.data.state);
export const selectAccessToken = createSelector(selectAuthFeat, (auth: IAuth) => auth.access_token);
export const selectAvatar = createSelector(selectAuthFeat, (auth: IAuth) => auth.avatarUrl);
export const selectUserSettings = createSelector(selectAuthFeat, (auth: IAuth) => auth.user?.settings);
export const selectLang = createSelector(selectAuthFeat, (auth: IAuth) => auth.user.settings.lang);
export const selectPixKey = createSelector(selectAuthFeat, (auth: IAuth) => auth.user.settings.pixKey);
export const selectFavouritebetType = createSelector(
  selectAuthFeat,
  (auth: IAuth) => auth.user.settings.favouriteBetType,
);
export const selectBookmarks = createSelector(selectAuthFeat, (auth: IAuth) => auth.user?.settings.bookmarks || []);
export const selectLangWallet = createSelector(selectAuthFeat, (auth: IAuth) => ({
  currency: auth.user.settings.currency,
  lang: auth.user.settings.lang,
}));
